import React from "react";
import BreadCrumb from "../../../Common/BreadCrumb";
import Dropdown from "../../../Common/Components/Dropdown/Index";

const DropdownPage = () => {
  const dropdownItems = ["Action", "Another action", "Something else here"];

  return (
    <React.Fragment>
      <BreadCrumb title="Dropdowns" pageType="Elements" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Dropdowns Default
            </h2>
            <div className="flex flex-wrap justify-center gap-3">
              <div className="flex flex-wrap gap-4">
                <Dropdown
                  classname="btn bg-purple border-purple text-white hover:bg-purple/[0.85] hover:border-purple/[0.85] flex items-center justify-center"
                  btnName="Primary"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-info border-info text-white hover:bg-info/[0.85] hover:border-info/[0.85] flex items-center justify-center"
                  btnName="Info"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-success border-success text-white hover:bg-success/[0.85] hover:border-success/[0.85] flex items-center justify-center"
                  btnName="Success"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-warning border-warning text-white hover:bg-warning/[0.85] hover:border-warning/[0.85] flex items-center justify-center"
                  btnName="Warning"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-danger border-danger text-white hover:bg-danger/[0.85] hover:border-danger/[0.85] flex items-center justify-center"
                  btnName="Danger"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-black border-black text-white hover:bg-black/[0.85] hover:border-black/[0.85] flex items-center justify-center"
                  btnName="Black"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-muted border-muted text-white hover:bg-muted/[0.85] hover:border-muted/[0.85] flex items-center justify-center dark:bg-darkmuted dark:border-darkmuted dark:hover:bg-darkmuted/90 dark:hover:border-darkmuted/90"
                  btnName="Secondary"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-light border-light text-black hover:bg-light/[0.85] hover:border-light/[0.85] flex items-center justify-center"
                  btnName="Light"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
              </div>
            </div>
          </div>

          {/* Rounded */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Dropdowns Rounded
            </h2>
            <div className="flex flex-wrap justify-center gap-3">
              <div className="flex flex-wrap gap-4">
                <Dropdown
                  classname="btn rounded-full bg-purple border-purple text-white hover:bg-purple/[0.85] hover:border-purple/[0.85] flex items-center justify-center"
                  btnName="Primary"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-info border-info rounded-full text-white hover:bg-info/[0.85] hover:border-info/[0.85] flex items-center justify-center"
                  btnName="Info"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-success border-success rounded-full text-white hover:bg-success/[0.85] hover:border-success/[0.85] flex items-center justify-center"
                  btnName="Success"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-warning border-warning rounded-full text-white hover:bg-warning/[0.85] hover:border-warning/[0.85] flex items-center justify-center"
                  btnName="Warning"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-danger border-danger rounded-full text-white hover:bg-danger/[0.85] hover:border-danger/[0.85] flex items-center justify-center"
                  btnName="Danger"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-black border-black rounded-full text-white hover:bg-black/[0.85] hover:border-black/[0.85] flex items-center justify-center"
                  btnName="Black"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-muted border-muted rounded-full text-white hover:bg-muted/[0.85] hover:border-muted/[0.85] flex items-center justify-center"
                  btnName="Secondary"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="btn bg-light border-light rounded-full text-black hover:bg-light/[0.85] hover:border-light/[0.85] flex items-center justify-center"
                  btnName="Light"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
              </div>
            </div>
          </div>

          {/* Outline */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Dropdowns Outline Default
            </h2>
            <div className="flex flex-wrap justify-center gap-3">
              <div className="flex flex-wrap gap-4">
                <Dropdown
                  classname="flex items-center justify-center btn text-purple border-purple hover:text-white hover:bg-purple"
                  btnName="Primary"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center btn text-info border-info hover:text-white hover:bg-info"
                  btnName="Info"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center btn text-success border-success hover:text-white hover:bg-success"
                  btnName="Success"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center btn text-warning border-warning hover:text-white hover:bg-warning"
                  btnName="Warning"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center btn text-danger border-danger hover:text-white hover:bg-danger"
                  btnName="Danger"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center text-black transition-all duration-300 border border-black rounded-md btn hover:text-white hover:bg-black dark:text-white dark:hover:text-white dark:border-darkborder dark:hover:border-black"
                  btnName="Black"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center btn text-muted border-muted hover:text-white hover:bg-muted dark:text-darkmuted dark:border-darkmuted dark:hover:text-white"
                  btnName="Secondary"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center text-black btn border-light hover:text-black hover:bg-light dark:text-white dark:hover:text-black"
                  btnName="Light"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
              </div>
            </div>
          </div>

          {/* Outline Rounded */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Dropdowns Outline Rounded
            </h2>
            <div className="flex flex-wrap justify-center gap-3">
              <div className="flex flex-wrap gap-4">
                <Dropdown
                  classname="flex items-center justify-center rounded-full btn text-purple border-purple hover:text-white hover:bg-purple"
                  btnName="Primary"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center rounded-full btn text-info border-info hover:text-white hover:bg-info"
                  btnName="Info"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center rounded-full btn text-success border-success hover:text-white hover:bg-success"
                  btnName="Success"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center rounded-full btn text-warning border-warning hover:text-white hover:bg-warning"
                  btnName="Warning"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center rounded-full btn text-danger border-danger hover:text-white hover:bg-danger"
                  btnName="Danger"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center text-black border-black rounded-full btn hover:text-white hover:bg-black dark:text-white dark:hover:text-white dark:border-darkborder dark:hover:border-black"
                  btnName="Black"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center rounded-full btn text-muted border-muted hover:text-white hover:bg-muted dark:text-darkmuted dark:border-darkmuted dark:hover:text-white"
                  btnName="Secondary"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
                <Dropdown
                  classname="flex items-center justify-center text-black rounded-full btn border-light hover:text-black hover:bg-light dark:text-white dark:hover:text-black"
                  btnName="Light"
                  isIcon={true}
                  dropdownItems={dropdownItems}
                />
              </div>
            </div>
          </div>

          {/* Dropdown */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Dropdowns
            </h2>
            <div className="flex flex-wrap justify-center gap-3">
              <Dropdown
                classname="btn bg-purple border-purple text-white hover:bg-purple/[0.85] hover:border-purple/[0.85] flex items-center justify-center"
                btnName="Dropdown Menu"
                isIcon={true}
                dropdownItems={dropdownItems}
              />
              <Dropdown
                classname="btn bg-black border-black text-white hover:bg-black/[0.85] hover:border-black/[0.85] flex items-center justify-center"
                btnName="Dropdown Menu"
                isIcon={true}
                dropdownItems={dropdownItems}
              />
            </div>
          </div>

          {/* Split Button */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Dropdowns Split Button
            </h2>
            <div className="flex flex-wrap justify-center gap-4">
              <Dropdown
                classname="inline-flex align-middle bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                btnName="Primary"
                isIcon={false}
                dropdownItems={dropdownItems}
              />
              <Dropdown
                classname="inline-flex align-middle bg-success border border-success rounded-md text-white transition-all duration-300 hover:bg-success/[0.85] hover:border-success/[0.85]"
                btnName="Primary"
                isIcon={false}
                dropdownItems={dropdownItems}
              />
              <Dropdown
                classname="inline-flex align-middle bg-black border border-black rounded-md text-white transition-all duration-300 hover:bg-black/[0.85] hover:border-black/[0.85]"
                btnName="Primary"
                isIcon={false}
                dropdownItems={dropdownItems}
              />
              <Dropdown
                classname="inline-flex align-middle bg-light border border-light rounded-md text-black transition-all duration-300 hover:bg-light/[0.85] hover:border-light/[0.85]"
                btnName="Primary"
                isIcon={false}
                dropdownItems={dropdownItems}
              />
            </div>
          </div>

          {/* With Icon */}
          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Dropdown With icons
            </h2>
            <div className="flex flex-wrap justify-center gap-4">
              <Dropdown
                classname="p-3 bg-purple border border-purple rounded-md text-white transition-all duration-300 hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                isSvg={true}
                svgName="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10ZM19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
                isIcon={true}
                dropdownItems={dropdownItems}
              />
              <Dropdown
                classname="p-3 bg-success border border-success rounded-md text-white transition-all duration-300 hover:bg-success/[0.85] hover:border-success/[0.85]"
                isSvg={true}
                svgName="M12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5C14 3.9 13.1 3 12 3ZM12 17C10.9 17 10 17.9 10 19C10 20.1 10.9 21 12 21C13.1 21 14 20.1 14 19C14 17.9 13.1 17 12 17ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
                isIcon={true}
                dropdownItems={dropdownItems}
              />
              <Dropdown
                classname="p-3 bg-black border border-black rounded-md text-white transition-all duration-300 hover:bg-black/[0.85] hover:border-black/[0.85]"
                isSvg={true}
                svgName="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
                isIcon={true}
                dropdownItems={dropdownItems}
              />
              <Dropdown
                classname="p-3 bg-light border border-light rounded-md text-black transition-all duration-300 hover:bg-light/[0.85] hover:border-light/[0.85]"
                isSvg={true}
                svgName="M11.9997 13.1714L16.9495 8.22168L18.3637 9.63589L11.9997 15.9999L5.63574 9.63589L7.04996 8.22168L11.9997 13.1714Z"
                isIcon={true}
                dropdownItems={dropdownItems}
              />
            </div>
          </div>

          {/* Sizes */}

          <div className="card">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Dropdown Sizes
            </h2>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Dropdown
                classname="btn bg-purple border-purple text-white hover:bg-purple/[0.85] hover:border-purple/[0.85] flex items-center justify-center"
                isIcon={true}
                dropdownItems={dropdownItems}
                btnName="Primary"
              />
              <Dropdown
                classname="btn py-2 px-5 text-[15px] bg-success border-success text-white hover:bg-success/[0.85] hover:border-success/[0.85] flex items-center justify-center"
                btnName="Primary"
                isIcon={true}
                dropdownItems={dropdownItems}
              />
              <Dropdown
                classname="btn py-1.5 px-4 text-sm bg-black border-black text-white hover:bg-black/[0.85] hover:border-black/[0.85] flex items-center justify-center"
                isIcon={true}
                dropdownItems={dropdownItems}
                btnName="Primary"
              />
              <Dropdown
                classname="btn py-1 px-3.5 text-[13px] bg-light border-light text-black hover:bg-light/[0.85] hover:border-light/[0.85] flex items-center justify-center"
                btnName="Primary"
                isIcon={true}
                dropdownItems={dropdownItems}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DropdownPage;
